import { createSelector } from "@reduxjs/toolkit";

import { IDataKeys } from "shared/types";

import { IScheduledFlight } from "Bands/types";
import { buildData, dataSelector } from "./helpers";

export const flightSelector = createSelector(
  dataSelector,
  data => buildData(data as any, IDataKeys.scheduledFlight) as IScheduledFlight[]
);
